const whiteList: Array<string> = [
    'setGlobalData',

    // 缩小
    'zoomIn',

    // 放大
    'zoomOut',

    // 层板文字模式信息更新
    'updateLayerTxt',
    'changeRenderMode',
    'tagsChangeSetting',
    'changeSetting',
    'selectCubes',
    'firstRenderDone',
    'cabinetSkuColLayout',
    'selectEdit',
    'showModal',
    'addNew',
    'UpdateDone',
    'addGoodsToSketchpad',
    'savePage',
    'refresh',
    'panelCubeRemove',
    'refreshColorModel'
];

export default whiteList;
